import { render, staticRenderFns } from "./AddContent.vue?vue&type=template&id=2965afd5&scoped=true&"
import script from "./AddContent.vue?vue&type=script&lang=js&"
export * from "./AddContent.vue?vue&type=script&lang=js&"
import style0 from "./AddContent.vue?vue&type=style&index=0&id=2965afd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965afd5",
  null
  
)

export default component.exports